module.exports = __webpack_public_path__ + "75241fd3dd9277227dc72354e0618ca3.svg";